import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from '@angular/material/tree';
import * as _ from 'lodash';

import {
  BRAND_ROUTE,
  COLLECTION_LIST_ROUTE,
  COVER_IMAGE_ROUTE,
  DESTINATION_LIST_ROUTE,
  DOCUMENT_ROUTE,
  EXTERNAL_LINK_ROUTE,
  FEATURED_PRODUCTS_ROUTE,
  GROUPS_ROUTE,
  MESSAGE_ROUTE,
  NEWS_ROUTE,
  SEASON_LIST_ROUTE,
  SEASON_WORKBENCH_LIST_ROUTE,
  STATIC_CONTENT_ROUTE,
  USER_ROUTE,
  WEB_SERVICE_ROUTE,
} from '../../../../constants/app-url-constants';
import { MenuService } from '../../../shared/services/menu.service';

import { MenuData, ExampleFlatNode } from '../../../shared/models/menu.model';
@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styles: [],
})
export class NavBarComponent implements OnInit {
  transformer: any;
  dataSource: any;
  treeControl: any;
  treeFlattener: any;
  hasChild: any;

  constructor(private menuService: MenuService) {}
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  collectionsRoute = COLLECTION_LIST_ROUTE;
  featuredProductsRoute = FEATURED_PRODUCTS_ROUTE;
  seasonsRoute = SEASON_LIST_ROUTE;
  destinationsRoute = DESTINATION_LIST_ROUTE;
  webServiceRoute = WEB_SERVICE_ROUTE;
  newsRoute = NEWS_ROUTE;
  coverImageRoute = COVER_IMAGE_ROUTE;
  documentsRoute = DOCUMENT_ROUTE;
  externalLinksRoute = EXTERNAL_LINK_ROUTE;
  staticContentRoute = STATIC_CONTENT_ROUTE;
  messagesRoute = MESSAGE_ROUTE;
  brandRoute = BRAND_ROUTE;
  userRoute = USER_ROUTE;
  groupRoute = GROUPS_ROUTE;
  seasonWorkBenchRoute = SEASON_WORKBENCH_LIST_ROUTE;
  menuData: MenuData[] = [];
  isLoaded = false;

  ngOnInit() {
    this.transformer = (node: MenuData, level: number) => ({
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level,
      route: node.route,
    });
    this.treeControl = new FlatTreeControl<ExampleFlatNode>(
      (node) => {
        return node.level;
      },
      (node) => node.expandable
    );
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      (node: any) => node.level,
      (node) => node.expandable,
      (node: any) => node.children
    );
    this.dataSource = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );
    this.hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
    this.menuService.getMenuData().subscribe((response: any) => {
      this.menuData = [];
      _.map(response.data, (val, key) => {
        if (key === '') {
          val.forEach((element) => {
            const data: any = { name: '', children: [], route: '' };
            data.name = element.name;
            if (response.data[element.name]) {
              data.children = [];
              response.data[element.name].forEach((innerMenu) => {
                data.children.push({
                  name: innerMenu.name,
                  route: '/' + innerMenu.url,
                });
              });
            } else {
              data.route = '/' + element.url;
            }
            this.menuData.push(data);
          });
          this.dataSource.data = this.menuData;
          this.isLoaded = true;
          return this.menuData;
        }
      });
    });
  }

  openMyMenu() {
    this.trigger.toggleMenu();
  }

  closeMyMenu() {
    this.trigger.closeMenu();
  }
}
